import { ALL, UrlState } from "@multimediallc/cb-roomlist-prefetch"
import { normalizeResource } from "../../../common/api"
import { i18n } from "../../../common/translation"
import { dom } from "../../../common/tsxrender/dom"
import { SearchBlur } from "./constants"
import { MobileSearchPaneInputSuggestions } from "./mobileSearchPaneInputSuggestions"
import { SearchInput } from "./searchInput"
import type { ISearchInputProps } from "./searchInput"

export class MobileSearchPaneInput extends SearchInput {

    protected createElement(): HTMLDivElement {
        // Two dummy inputs for text/password are added in the form
        // in order to prevent chrome autofill suggestions from popping up on focus.
        return <div className="SearchInput" id="SearchInput">
            <div className="SearchPane__search-icon" />
            <form id="filter_search_form" method="GET" action={normalizeResource("/")}
                ref={(el: HTMLFormElement) => { this.form = el }}
            >
                <input type="text" style={{ display: "none" }} />
                <input type="password" style={{ display: "none" }} />
                <input id="keywords" name="keywords" className="SearchPane__inputBar" maxLength={150}
                    placeholder={i18n.searchBarPlaceholder} type="text" autocomplete="off"
                    ref={(el: HTMLInputElement) => { this.input = el }}
                    onFocus={(e: FocusEvent) => {
                        if (this.isFocusInsideSearch(e)) {
                            this.onInputFocus()
                        }
                    }}
                    onBlur={(e: FocusEvent) => { SearchBlur.fire(e) }}
                    onInput={() => { this.onInput() }}
                    onKeyDown={(e: KeyboardEvent) => { this.inputKeyDown(e) }}
                />
                <div className="inputDelete searchPane" ref={(el: HTMLDivElement) => { this.delete = el }}

                    onMouseDown={(e: MouseEvent) => {
                        if (e.ctrlKey || e.metaKey || e.button === 2) {
                            return
                        }
                        this.onInputDeleteClick(e)
                    }}
                />
                {this.initSuggestions()}
            </form>
        </div>
    }

    protected initUI(props?: ISearchInputProps): void {
        super.initUI(props)
        UrlState.current.listen(ALL, (newState) => {
            const urlKeywords = newState.keywords ?? ""
            this.input.value = urlKeywords
            this.styleInputDelete()
            this.suggestionsDiv.hideSuggestions()
        }, this.element)
    }

    protected initSuggestions(): MobileSearchPaneInputSuggestions {
        return <MobileSearchPaneInputSuggestions
            classRef={(ref) => { this.suggestionsDiv = ref }}
            input={this.input}
            searchInput={this}
        />
    }
}
